/* eslint-disable react/require-default-props */

/* eslint-disable no-sequences */
import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { MaterialUiIcons } from '@gscope-mfe/common-libs';
import classes from './Wizard.module.css';
import root from './overWriteStyle';
const { DialogActions } = MaterialUiCore;
const { DialogTitle } = MaterialUiCore;
const { DialogContent } = MaterialUiCore;
const { Dialog } = MaterialUiCore;
const CloseIcon = MaterialUiIcons.Close;
const { StepLabel } = MaterialUiCore;
const { Step } = MaterialUiCore;
const { Stepper } = MaterialUiCore;
const { makeStyles } = MaterialUiCore;
const useStyles = makeStyles(() => ({
    root,
}));
export default function Wizard(props) {
    const wizardClass = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const {
        steps,
        title,
        isSaveDraft,
        getContent,
        completeBtnText,
        handleSaveDraft,
        handleCancel,
        handleComplete,
        open,
    } = props;

    function getStepContent(stepIndex) {
        return getContent(stepIndex);
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    return (
        <Dialog
            className={(classes.rootContainer, wizardClass.root)}
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
                <CloseIcon className={classes.closeIcon} fontSize="small" onClick={handleCancel} />
            </DialogTitle>
            <DialogContent>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel onClick={handleStep(index)}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div className={classes.contentContainer}>
                    {activeStep !== steps.length && (
                        <div className={classes.instructions}>{getStepContent(activeStep)}</div>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                {activeStep !== steps.length && (
                    <div className={classes.btnContainer}>
                        <div className={classes.btnContainerChild}>
                            {activeStep > 0 && (
                                <button
                                    className={`secondaryBtn secondaryBtnEnabled ${classes.wizardBtn}`}
                                    type="button"
                                    onClick={handleBack}
                                >
                                    Back
                                </button>
                            )}
                        </div>
                        <div>
                            <button
                                type="button"
                                onClick={handleCancel}
                                className={`textBtn textBtnEnabled ${classes.wizardBtn}`}
                            >
                                Cancel
                            </button>
                            {isSaveDraft && (
                                <button
                                    type="button"
                                    onClick={handleSaveDraft}
                                    className={`secondaryBtn secondaryBtnEnabled ${classes.wizardBtn}`}
                                >
                                    Save As Draft
                                </button>
                            )}
                            {activeStep === steps.length - 1 ? (
                                <button
                                    type="button"
                                    className={`primaryBtn primaryBtnEnabled ${classes.wizardBtn} ${classes.saveBtn}`}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleComplete}
                                >
                                    {completeBtnText}
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className={`primaryBtn primaryBtnEnabled ${classes.wizardBtn} ${classes.saveBtn}`}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleNext}
                                >
                                    Next
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </DialogActions>
        </Dialog>
    );
} // Specifies the default values for props:

Wizard.defaultProps = {
    completeBtnText: 'Complete',
    isSaveDraft: false,
};
Wizard.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    isSaveDraft: PropTypes.bool,
    getContent: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleSaveDraft: PropTypes.func,
    handleComplete: PropTypes.func.isRequired,
    completeBtnText: PropTypes.string,
    open: PropTypes.bool.isRequired,
};
